import { createFileRoute } from '@tanstack/react-router';
import DocumentsPage from '@/pages/documents/DocumentsPage';
import { documentsSearchSchema } from '@/pages/documents/search-schema';

export const Route = createFileRoute('/_authenticated/documents/')({
  component: DocumentsPage,
  validateSearch: documentsSearchSchema,
});
